import React from "react";
import { HeartIcon as HeartOutline } from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import { useFavorites } from "./FavoritesContext";
import { reachGoal } from "../utils/metrika";

/**
 * Сердечко «в избранное». Ставится рядом с кнопкой или ссылкой карточки, а не внутрь:
 * клик не должен открывать покупку или переходить по ссылке.
 */
function HeartButton({ item, className = "" }) {
  const { isFavorite, toggle } = useFavorites();
  if (!item?.gameKey) return null;
  const on = isFavorite(item);
  const label = on ? "Убрать из избранного" : "Добавить в избранное";
  const Icon = on ? HeartSolid : HeartOutline;
  return (
    <button
      type="button"
      aria-pressed={on}
      aria-label={label}
      title={label}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!on) reachGoal("favorite_add", { platform: item.platform });
        toggle(item);
      }}
      className={`fav-heart${on ? " fav-heart--on" : ""} ${className}`}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}

export default HeartButton;
